import React, { MouseEventHandler } from 'react';
import { Button, Flex, Text } from 'rebass';
import styled from '@emotion/styled';

import ErrorDetails from './ErrorDetails';
import useNotify from '../../hooks/useNotify';
import colors from '../../theme/colors';
import theme from '../../theme';

const StyledErrorPopup = styled(Flex)`
  position: absolute;
  flex-direction: column;
  bottom: 3vh;
  right: 2vw;
  z-index: 11;
  opacity: 1;
  max-width: 50vw;
  max-height: 400px;
  background-color: #d9534f;
  color: white;
  margin-right: 20px;
  padding: 10px 20px;
  border-radius: 25px;
  align-items: center;
  justify-content: center;
  animation: fadeIn 1s;
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const StyledSuccessPopup = styled(Flex)`
  position: absolute;
  bottom: 3vh;
  right: 2vw;
  z-index: 11;
  opacity: 1;
  background-color: #29ba63;
  color: white;
  margin-right: 20px;
  padding: 10px 20px;
  border-radius: 25px;
  align-items: center;
  justify-content: center;
  animation: fadeIn 1s;
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const StyledWarnMessage = styled(Flex)`
  background-color: ${colors.statusOrange};
  color: white;
  padding: 8px 16px;
  border-radius: ${theme.radii.default}px;
  align-items: center;
  justify-content: center;
`;

const StyledWarnPopup = styled(StyledWarnMessage)`
  position: absolute;
  bottom: 3vh;
  right: 2vw;
  z-index: 11;
  opacity: 1;
  padding: 10px 20px;
  border-radius: 25px;
  margin-right: 20px;
  animation: fadeIn 1s;
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

function Notification(): JSX.Element {
  const { notification, removeNotification } = useNotify();

  const handleSubmit: MouseEventHandler = (e) => {
    removeNotification();
    e.preventDefault();
  };

  if (!notification) {
    return <></>;
  }

  const { type, message, errorDetails = '' } = notification;
  switch (type) {
    case 'error':
      return (
        <StyledErrorPopup>
          <Text>{message}</Text>
          <br />
          <ErrorDetails errorDetails={errorDetails} />
          <Button ml={5} px={2} variant="outline" onClick={handleSubmit}>
            Ok
          </Button>
        </StyledErrorPopup>
      );
    case 'success':
      return (
        <StyledSuccessPopup>
          <Text>{notification.message}</Text>
        </StyledSuccessPopup>
      );
    case 'warn':
      return (
        <StyledWarnPopup>
          <Text>{notification.message}</Text>
        </StyledWarnPopup>
      );
  }
}

export default Notification;
